<template>
  <div class="error-box">
    <div class="error-box__content">
      <img :src="require(`../../assets/img/${picture}`)" />
      <p>{{ content }}</p>
      <van-button v-if="isShowBtn" @click="onClick" class="error-box__content--button" type="primary" :color="btnBackground" :style="[btnTextColor ? `color: ${btnTextColor}` : 'color: #272727']"
        >{{ btnText }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from '@vue/runtime-core'
import { Button } from 'vant'

interface IHeaderState {
  onClick: () => void
}

export default {
  components: {
    [Button.name as string]: Button
  },
  props: {
    handleOpenApp: {
      type: Function as PropType<() => void>,
      required: false
    },
    picture: {
      type: String as PropType<string>,
      default: 'empty.png'
    },
    btnBackground: {
      type: String as PropType<string>
    },
    btnTextColor: {
      type: String as PropType<string>
    },
    content: {
      type: String as PropType<string>,
      default: '暂无数据，下载App体验更多功能吧'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    isShowBtn: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup(
    props: Readonly<{
      handleOpenApp?: () => void
    }>
  ): IHeaderState {
    const onClick = () => {
      props.handleOpenApp && props.handleOpenApp()
    }

    return {
      onClick
    }
  }
}
</script>

<style lang="scss" scoped>
@include b(error-box) {
  background-color: #fff;
  height: 100vh;
  position: relative;
  background-image: url('~@/../src/assets/imgReplace/web-bg.png');
  width: 100%;
  background-repeat: no-repeat;
  background-position: top;
  top: -4.5rem;
  background-size: 100% 30%;
  @include e(content) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    font-size: 40px;
    font-weight: bold;
    text-align: center;

    img {
      width: 300px;
    }

    p {
      font-size: 28px;
      color: $color-text-secondary;
      font-weight: normal;
      margin-top: 20px;
      margin-bottom: 80px;
      padding: 0px 15px;
      color: #8e9899;
    }

    @include m(button) {
      width: 300px;
      height: 80px;
      font-weight: bold;
      font-size: 25px;
      border-radius: 40px;
      margin: 0 auto;
      box-sizing: border-box;
    }
  }
}
@media (max-height: 500px) {
  @include b(error-box) {
    @include e(content) {
      img {
        width: 220px !important;
      }
    }
  }
}
</style>
